import {
  OpportunitySelectionType,
  OpportunityType
} from '__core/shared/model/opportunity/Opportunity.enum';
import { OpportunityContextualType } from '__core/shared/model/opportunity/OpportunityContextual.enum';
import OpportunityContextual from '__core/shared/model/opportunity/OpportunityContextual';
import OpportunityConfiguration from '__core/shared/model/opportunity/OpportunityConfiguration';
import diversificationOpportunityService from './diversificationOpportunity.service';
import stDiversificationOpportunity from './diversificationOpportunity.component';
import stDiversificationOpportunities from './diversificationOpportunities.component';
import diversificationIntegrationService from './diversificationIntegrations.service';
import stDiversificationIntegrations from './diversificationIntegrations.component';
import diversificationController from './diversification.controller';

export default angular
  .module('st.Diversification', ['st.Core'])
  .factory('OpportunityType', () => OpportunityType)
  .factory('OpportunityContextualType', () => OpportunityContextualType)
  .factory('OpportunitySelectionType', () => OpportunitySelectionType)
  .factory('OpportunityContextual', () => OpportunityContextual)
  .factory('OpportunityConfiguration', () => OpportunityConfiguration)
  .service('diversificationOpportunityService', diversificationOpportunityService)
  .component('stDiversificationOpportunity', stDiversificationOpportunity)
  .component('stDiversificationOpportunities', stDiversificationOpportunities)
  .service('diversificationIntegrationService', diversificationIntegrationService)
  .component('stDiversificationIntegrations', stDiversificationIntegrations)
  .controller('diversificationController', diversificationController);
